<template>
  <div class="col" align-x="center" gutter="35">
    <div class="col" align-x="center" gutter="5">
      <h1>註冊個人帳號</h1>
      <span>註冊者須滿18歲</span>
    </div>
    <el-form :model="ruleForm" :rules="rules" ref="registerProfileForm">
      <el-form-item prop="name">
        <el-input v-model="ruleForm.name" placeholder="中文全名"></el-input>
      </el-form-item>
      <el-form-item label="姓名拼音" prop="enName" required>
        <el-row type="flex">
          <el-input
            v-model="ruleForm.enName"
            placeholder="建議威妥瑪(WG)拼音"
            class="normal-input"
          ></el-input>
          <a
            href="https://www.boca.gov.tw/sp-natr-singleform-1.html"
            target="_blank"
            class="color-blue1 en-name-link"
            >外交部外文姓名中譯英系統查詢</a
          >
        </el-row>
      </el-form-item>

      <!-- <el-form-item prop="gender">
				<el-radio-group v-model="ruleForm.gender">
					<el-radio label="生理男" value="male">生理男</el-radio>
					<el-radio label="生理女" value="female">生理女</el-radio>
				</el-radio-group>
			</el-form-item> -->

      <el-form-item prop="born">
        <el-row type="flex" :gutter="10">
          <el-col>
            <el-date-picker
              v-model="ruleForm.born"
              type="date"
              format="yyyy 年 MM 月 dd 日"
              value-format="timestamp"
              placeholder="出生年月日"
            ></el-date-picker>
          </el-col>
        </el-row>
      </el-form-item>

      <el-form-item prop="phone">
        <el-input v-model="ruleForm.phone" placeholder="手機"></el-input>
      </el-form-item>
      <el-form-item prop="tel">
        <el-input
          v-model="ruleForm.tel"
          placeholder="學校電話（分機）"
        ></el-input>
      </el-form-item>

      <el-form-item>
        <el-form-item label="Email">{{ userInfo.email }}</el-form-item>
      </el-form-item>
      <el-form-item prop="job">
        <el-select v-model="ruleForm.job" placeholder="職業">
          <el-option label="教育工作者" value="教育工作者"></el-option>
          <el-option
            :label="occupation"
            :value="occupation"
            v-for="(occupation, index) in occupations"
            :key="index"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item v-if="showTeacherOptions" prop="teacherGrade">
        <el-radio-group
          v-model="ruleForm.teacherGrade"
          @change="getTeacherSchool"
        >
          <el-radio label="elementary">國小</el-radio>
          <el-radio label="junior">國中</el-radio>
          <el-radio label="senior">高中</el-radio>
          <el-radio label="others">其他</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-row type="flex" :gutter="20">
        <el-form-item prop="city">
          <el-col>
            <el-select
              v-model="ruleForm.city"
              placeholder="選擇縣市"
              @change="getTeacherSchool"
            >
              <el-option
                :label="city"
                :value="city"
                v-for="(city, index) in cities"
                :key="index"
              ></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item prop="district">
          <el-col>
            <el-select
              v-model="ruleForm.district"
              placeholder="選擇區域"
              @change="getTeacherSchool"
            >
              <el-option
                :label="district"
                :value="district"
                v-for="(district, index) in districts"
                :key="index"
              ></el-option>
            </el-select>
          </el-col>
        </el-form-item>
      </el-row>

      <el-form-item prop="department">
        <el-select
          v-if="showTeacherOptions && ruleForm.teacherGrade != 'others'"
          v-model="ruleForm.department"
          placeholder="單位名稱"
        >
          <el-option
            :label="school.name"
            :value="school.name"
            v-for="(school, i) in schoolList"
            :key="i"
            >{{ school.name }}</el-option
          >
        </el-select>
        <el-input
          v-else
          v-model="ruleForm.department"
          placeholder="單位名稱"
        ></el-input>
      </el-form-item>

      <el-form-item v-if="showTeacherOptions" prop="position">
        <el-select v-model="ruleForm.position" placeholder="職位名稱">
          <el-option
            :label="position"
            :value="position"
            v-for="(position, index) in positions"
            :key="index"
          ></el-option>
        </el-select>
        <div v-if="ruleForm.position === '其他'" class="other-input">
          其他：<input type="text" v-model="positionOther" />
        </div>
      </el-form-item>
      <el-form-item v-else prop="position">
        <el-input v-model="positionOther" placeholder="職位名稱"></el-input>
      </el-form-item>
      <el-form-item v-if="showTeacherOptions" prop="teacherSubject">
        <el-select v-model="ruleForm.teacherSubject" placeholder="任教領域">
          <el-option
            :label="teacherSubject"
            :value="teacherSubject"
            v-for="(teacherSubject, index) in teacherSubjects"
            :key="index"
          ></el-option>
        </el-select>
        <div
          v-if="
            ruleForm.teacherSubject === '其他（彈性課程、校訂課程、其他等）'
          "
          class="other-input"
        >
          其他：<input type="text" v-model="teacherSubjectOther" />
        </div>
      </el-form-item>

      <el-form-item>
        <el-checkbox v-model="unitNowChecked" @change="handleunitNowChecked"
          >我現在在這裡工作</el-checkbox
        >
      </el-form-item>

      <el-form-item prop="startTime">
        <el-row type="flex" :gutter="10">
          <el-col :span="10">
            <el-date-picker
              v-model="ruleForm.startTime"
              type="month"
              format="yyyy 年 MM 月"
              value-format="timestamp"
              placeholder="起始日期"
            ></el-date-picker>
          </el-col>
          <el-col :span="3">{{ unitNowChecked ? "至今" : "到" }}</el-col>
        </el-row>
      </el-form-item>

      <el-form-item v-if="!unitNowChecked" prop="endTime">
        <el-row type="flex" :gutter="10">
          <el-col :span="10">
            <el-date-picker
              v-model="ruleForm.endTime"
              type="month"
              format="yyyy 年 MM 月"
              value-format="timestamp"
              placeholder="結束日期"
            ></el-date-picker>
          </el-col>
          <el-col :span="3"></el-col>
        </el-row>
      </el-form-item>

      <el-form-item>
        <div
          class="button-tp normal-button register-btn color-text2 bg-black-gray3"
          @click="submitForm('registerProfileForm')"
        >
          註冊
        </div>
      </el-form-item>

      <el-form-item>
        <p class="center color-danger">{{ errorMessage }}</p>
      </el-form-item>
    </el-form>
    <SuccessDialog
      :visible.sync="successDialogVisible"
      @close="successDialogVisible = false"
    ></SuccessDialog>
  </div>
</template>

<script>
import SuccessDialog from "@/components/register/SuccessDialog";
import { mapActions, mapState } from "vuex";
var cityJson = require("@/data/city.json");
var occupationJson = require("@/data/occupation.json");
var positionJson = require("@/data/position.json");
var teacherSubjectJson = require("@/data/teacherSubject.json");

export default {
  data() {
    var validateTeacherGrade = (rule, value, callback) => {
      if (this.showTeacherOptions) {
        if (!value) {
          callback(new Error("請選擇"));
        }
      } else {
        callback();
      }
      callback();
    };
    var validatePositionOther = (rule, value, callback) => {
      if (this.showTeacherOptions) {
        // 教育工作者的驗證邏輯
        if (!this.ruleForm.position) {
          callback(new Error("請填寫職位"));
          return;
        }
        if (this.ruleForm.position === "其他" && !this.positionOther) {
          callback(new Error("請填寫"));
          return;
        }
      } else {
        // 非教育工作者的驗證邏輯
        if (!this.positionOther) {
          callback(new Error("請填寫職位"));
          return;
        }
      }
      callback();
    };
    var validateTeacherSubjectOther = (rule, value, callback) => {
      if (
        this.showTeacherOptions &&
        this.ruleForm.teacherSubject === "其他（彈性課程、校訂課程、其他等）"
      ) {
        if (!this.teacherSubjectOther) {
          callback(new Error("請填寫"));
        }
      }
      callback();
    };
    var validateDepartment = (rule, value, callback) => {
      if (
        this.showTeacherOptions &&
        this.ruleForm.teacherGrade &&
        this.ruleForm.teacherGrade !== "others"
      ) {
        // Only validate if we have a school list and the department is supposed to be selected from it
        if (this.schoolList && this.schoolList.length > 0) {
          const isValidSchool = this.schoolList.some(
            (school) => school.name === value
          );
          if (!isValidSchool) {
            callback(new Error("請選擇正確單位名稱"));
          }
        }
      }
      callback();
    };
    var validateEndTime = (rule, value, callback) => {
      if (!this.unitNowChecked) {
        if (!value) {
          callback(new Error("請選擇經歷結束時間"));
        }
      } else {
        callback();
      }
      callback();
    };
    return {
      positionOther: "",
      teacherSubjectOther: "",
      cities: Object.keys(cityJson),
      occupations: occupationJson,
      positions: positionJson,
      teacherSubjects: teacherSubjectJson,
      schoolList: [],
      unitNowChecked: false,
      successDialogVisible: false,
      errorMessage: "",
      ruleForm: {
        endTime: null,
      },
      rules: {
        name: [{ required: true, message: "請輸入姓名", trigger: "blur" }],
        wade_giles: [
          {
            validator(rule, value, callback) {
              if (!value) callback(new Error("必填"));
              else if (!/^[A-Z][A-Z ]*,([A-Z]*-?){1,2}$/.test(value)) {
                callback(new Error("例：WANG,HSIAO-MING（姓,名-名）"));
              } else callback();
            },
            trigger: "blur",
          },
        ],
        // gender: [{ required: true, message: "請選擇性別", trigger: "change" }],
        born: [{ required: true, message: "請選擇出生日期", trigger: "blur" }],
        phone: [{ required: true, message: "請輸入聯絡電話", trigger: "blur" }],
        job: [{ required: true, message: "請選擇職業", trigger: "blur" }],
        city: [
          { required: true, message: "請選擇職業所在縣市", trigger: "blur" },
        ],
        district: [
          { required: true, message: "請選擇職業所在區域", trigger: "blur" },
        ],
        department: [
          { required: true, message: "請填寫職業單位", trigger: "blur" },
          { validator: validateDepartment, trigger: "change" },
        ],
        position: [{ validator: validatePositionOther, trigger: "blur" }],
        startTime: [
          { required: true, message: "請選擇經歷時間", trigger: "blur" },
        ],
        teacherGrade: [{ validator: validateTeacherGrade, trigger: "change" }],
        teacherSubject: [
          { required: true, message: "請填寫任教領域", trigger: "blur" },
          { validator: validateTeacherSubjectOther, trigger: "blur" },
        ],
        endTime: [{ validator: validateEndTime, trigger: "blur" }],
      },
    };
  },
  computed: {
    ...mapState("user", ["userInfo"]),
    showTeacherOptions() {
      return this.ruleForm.job == "教育工作者";
    },
    districts() {
      return cityJson[this.ruleForm.city] || [];
    },
  },
  methods: {
    ...mapActions("user", [
      "setAPIToken",
      "cleanToken",
      "registerProfile",
      "fetchUserInfo",
      "getSchool",
    ]),
    async getTeacherSchool() {
      if (
        this.ruleForm.teacherGrade &&
        this.ruleForm.city &&
        this.ruleForm.district
      ) {
        let data = {
          category: this.transTeacherGrade(this.ruleForm.teacherGrade),
          city: this.ruleForm.city,
          district: this.ruleForm.district,
        };
        this.schoolList = await this.getSchool(data);
      }
    },
    transTeacherGrade(teacherGrade) {
      switch (teacherGrade) {
        case "elementary":
          return 1;
        case "junior":
          return 2;
        case "senior":
          return 3;
      }
    },
    handleunitNowChecked(unitNowChecked) {
      this.ruleForm.endTime = unitNowChecked ? Date.now() : null;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.register();
        } else {
          this.errorMessage = "有資料尚未填寫完成";
          return false;
        }
      });
    },
    async register() {
      let data = {
        profile: {
          name: this.ruleForm.name,
          wade_giles: this.ruleForm.wade_giles,
          gender: this.ruleForm.gender,
          born_date: this.ruleForm.born,
          phone: this.ruleForm.phone,
          tel: this.ruleForm.tel,
          email: this.userInfo.email,
        },
        job: {
          type: this.ruleForm.job,
          city: this.ruleForm.city,
          district: this.ruleForm.district,
          department: this.ruleForm.department,
          position:
            this.ruleForm.job !== "教育工作者"
              ? `${this.positionOther}`
              : this.ruleForm.position === "其他"
              ? `其他，${this.positionOther}`
              : this.ruleForm.position,
          start_time: this.ruleForm.startTime,
          presently_employed: this.unitNowChecked,
        },
      };
      if (this.showTeacherOptions) {
        data.job.teacher_grade = this.ruleForm.teacherGrade;
        data.job.subject =
          this.ruleForm.teacherSubject === "其他（彈性課程、校訂課程、其他等）"
            ? `其他，${this.teacherSubjectOther}`
            : this.ruleForm.teacherSubject;
      }
      if (!this.unitNowChecked) {
        data.job.end_time = this.ruleForm.endTime;
      }

      try {
        await this.registerProfile(data);
        this.successDialogVisible = true;
      } catch (e) {
        this.errorMessage = e.message;
      }
    },
    async handleToken() {
      await this.cleanToken();
      let token = this.$route.query.token;
      await this.setAPIToken(token);
    },
    async fetchUser() {
      await this.fetchUserInfo();
    },
  },
  watch: {
    "ruleForm.job": function (newVal) {
      if (newVal !== "教育工作者" && this.$refs["registerProfileForm"]) {
        this.$refs["registerProfileForm"].clearValidate("teacherGrade");
      }
    },
    "ruleForm.position": function (newVal) {
      if (newVal !== "其他" && this.$refs["registerProfileForm"]) {
        this.$refs["registerProfileForm"].clearValidate("position");
      }
    },
    "ruleForm.teacherSubject": function (newVal) {
      if (
        newVal !== "其他（彈性課程、校訂課程、其他等）" &&
        this.$refs["registerProfileForm"]
      ) {
        this.$refs["registerProfileForm"].clearValidate("teacherSubject");
      }
    },
    "ruleForm.teacherGrade": function () {
      if (this.$refs["registerProfileForm"]) {
        this.$refs["registerProfileForm"].clearValidate("department");
      }
    },
    "ruleForm.city": function () {
      if (this.$refs["registerProfileForm"]) {
        this.$refs["registerProfileForm"].clearValidate("department");
      }
    },
    "ruleForm.district": function () {
      if (this.$refs["registerProfileForm"]) {
        this.$refs["registerProfileForm"].clearValidate("department");
      }
    },
  },
  async created() {
    await this.handleToken();
    await this.fetchUser();
  },
  components: {
    SuccessDialog,
  },
};
</script>

<style lang="scss" scoped>
.el-form {
  max-width: 360px;
}
.el-input,
.el-select,
.el-button {
  width: 100%;
}
p.center {
  text-align: center;
}

.register-btn {
  width: 360px;
  height: 40px;
  border: solid 1px #cacfd4;
}
.other-input {
  color: #606266;
  font-weight: 500;
  input {
    color: #606266;
    border: 0px;
    border-bottom: 1px solid #000;
    background-color: transparent;
    font-weight: 500;
  }
}
:deep(.other-input + .el-form-item__error) {
  padding: 0;
  margin-top: -5px;
}
</style>
